
import { RevIllustration } from '@ds/components/Illustration'

import { PaymentAdvertisement } from '@payment'

export default {
  components: {
    PaymentAdvertisement,
    RevIllustration,
  },
}
